import React, { CSSProperties } from 'react';
import { Card, CardProps } from 'reactstrap';

export interface INSCardProps extends CardProps {
    id?: string;
    style?: CSSProperties;
    className?: string;
    children: React.ReactNode;
}

const NSCard = React.forwardRef<HTMLDivElement, INSCardProps>(({
    id, children, className = '', style = {}, onClick = () => {}, ...rest
}, ref) => (
    <Card innerRef={ref} className={`NSCard ${className}`} style={style} onClick={onClick} id={id} {...rest}>
        {children}
    </Card>
));

export default NSCard;
